import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a03a66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "product-image" }
const _hoisted_3 = { class: "product-info" }
const _hoisted_4 = { class: "product-features" }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "results" }
const _hoisted_8 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "variant-info" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "order-info" }
const _hoisted_14 = { class: "order-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_DxpShopifyImg = _resolveComponent("DxpShopifyImg")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/products" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Product details")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.infoAlert }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.informationCircle,
                        slot: "icon-only"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_button, { onClick: _ctx.openActiveJobs }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        color: _ctx.isJobPending ? "warning" : "",
                        icon: _ctx.hourglass,
                        slot: "icon-only"
                      }, null, 8, ["color", "icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DxpShopifyImg, {
                src: _ctx.current.product.mainImageUrl
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ion_item, {
                lines: "none",
                class: "product-title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.current.product.productName), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.$filters.getFeaturesList(_ctx.current.product.featureHierarchy, '1/COLOR/').length)
                  ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list_header, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("Colors")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_row, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$filters.getFeaturesList(_ctx.current.product.featureHierarchy, '1/COLOR/'), (colorFeature) => {
                                  return (_openBlock(), _createBlock(_component_ion_chip, {
                                    outline: _ctx.filters['color'] !== colorFeature,
                                    key: colorFeature,
                                    onClick: ($event: any) => (_ctx.filter(colorFeature, 'color'))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(colorFeature), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["outline", "onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$filters.getFeaturesList(_ctx.current.product.featureHierarchy, '1/SIZE/').length)
                  ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list_header, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("Sizes")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_row, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$filters.getFeaturesList(_ctx.current.product.featureHierarchy, '1/SIZE/'), (sizeFeature) => {
                                  return (_openBlock(), _createBlock(_component_ion_chip, {
                                    outline: _ctx.filters['size'] !== sizeFeature,
                                    key: sizeFeature,
                                    onClick: ($event: any) => (_ctx.filter(sizeFeature, 'size'))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(sizeFeature), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["outline", "onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Ordered after")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_chip, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        "aria-label": "ordered-after",
                        modelValue: _ctx.orderedAfter,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderedAfter) = $event)),
                        onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getVariantProducts())),
                        type: "date"
                      }, null, 8, ["modelValue"]),
                      (_ctx.orderedAfter)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.orderedAfter = "")),
                            icon: _ctx.close
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Ordered before")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_chip, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        "aria-label": "ordered-before",
                        modelValue: _ctx.orderedBefore,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderedBefore) = $event)),
                        onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getVariantProducts())),
                        type: "date"
                      }, null, 8, ["modelValue"]),
                      (_ctx.orderedBefore)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 0,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.orderedBefore = "")),
                            icon: _ctx.close
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Promised after")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_chip, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        "aria-label": "promised-after",
                        modelValue: _ctx.promisedAfter,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.promisedAfter) = $event)),
                        onIonChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getVariantProducts())),
                        type: "date"
                      }, null, 8, ["modelValue"]),
                      (_ctx.promisedAfter)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 0,
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.promisedAfter = "")),
                            icon: _ctx.close
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Promised before")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_chip, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        "aria-label": "promised-before",
                        modelValue: _ctx.promisedBefore,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.promisedBefore) = $event)),
                        onIonChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getVariantProducts())),
                        type: "date"
                      }, null, 8, ["modelValue"]),
                      (_ctx.promisedBefore)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 0,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.promisedBefore = "")),
                            icon: _ctx.close
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Loyalty status")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_chip, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.ribbon }, null, 8, ["icon"]),
                      _createVNode(_component_ion_select, {
                        "aria-label": "loyalty-status",
                        placeholder: _ctx.$t('select'),
                        onIonChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getVariantProducts())),
                        modelValue: _ctx.cusotmerLoyalty,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.cusotmerLoyalty) = $event)),
                        interface: "popover",
                        "interface-options": "{showBackdrop:false}"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cusotmerLoyaltyOptions, (key, value) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: key,
                              value: value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(key), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["placeholder", "modelValue"]),
                      (_ctx.cusotmerLoyalty)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 0,
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.cusotmerLoyalty = "")),
                            icon: _ctx.close
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { lines: "none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toggle, {
                    onIonChange: _cache[15] || (_cache[15] = ($event: any) => {_ctx.hasPromisedDate = !_ctx.hasPromisedDate; _ctx.getVariantProducts()}),
                    checked: !_ctx.hasPromisedDate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Only orders without promise date")), 1)
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ion_badge, { color: "success" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.current.totalPreOrders) + " " + _toDisplayString(_ctx.$t("pieces preordered")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_badge, { color: "secondary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.current.list.items.length ? _ctx.current.list.items.length : 0) + " " + _toDisplayString(_ctx.current.list.items.length > 1 ? _ctx.$t("variants") : _ctx.$t("variant")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              disabled: _ctx.isRefreshing,
              onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.isRefreshing = true; _ctx.refreshProducts()}),
              fill: "outline",
              size: "small",
              color: _ctx.isJobPending ? 'warning' : ''
            }, {
              default: _withCtx(() => [
                (!_ctx.isRefreshing)
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 0,
                      slot: "icon-only",
                      icon: _ctx.refresh
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                (_ctx.isRefreshing)
                  ? (_openBlock(), _createBlock(_component_ion_spinner, {
                      key: 1,
                      name: "crescent"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled", "color"])
          ]),
          (!_ctx.filteredProducts(_ctx.current.list.items).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("There are no preorders for the filters you have applied and variants you have selected.")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedList(_ctx.filteredProducts(_ctx.current.list.items)), (item) => {
                  return (_openBlock(), _createBlock(_component_ion_card, {
                    key: item.groupValue
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_ion_item, { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxpShopifyImg, {
                                  src: _ctx.getProduct(item.groupValue).mainImageUrl,
                                  size: "small"
                                }, null, 8, ["src"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.getProduct(item.groupValue).productName), 1),
                                (_ctx.$filters.getFeature(_ctx.getProduct(item.groupValue).featureHierarchy, '1/COLOR/'))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t("Color")) + ": " + _toDisplayString(_ctx.$filters.getFeature(_ctx.getProduct(item.groupValue).featureHierarchy, '1/COLOR/')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.$filters.getFeature(_ctx.getProduct(item.groupValue).featureHierarchy, '1/SIZE/'))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("Size")) + ": " + _toDisplayString(_ctx.$filters.getFeature(_ctx.getProduct(item.groupValue).featureHierarchy, '1/SIZE/')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ion_badge, {
                          button: "",
                          color: "success",
                          onClick: ($event: any) => (_ctx.autoFillQuantity(item, item.doclist && item.doclist.numFound ? item.doclist.numFound : 0))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.doclist && item.doclist.numFound ? item.doclist.numFound : 0) + " " + _toDisplayString(_ctx.$t("pieces preordered")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_ion_badge, {
                          button: "",
                          color: "medium",
                          onClick: ($event: any) => (_ctx.autoFillQuantity(item, _ctx.getProductStock(item.groupValue)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getProductStock(item.groupValue)) + " " + _toDisplayString(_ctx.$t("in stock")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_ion_badge, { color: "medium" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getBrokeringCountByProduct(item.groupValue)) + " " + _toDisplayString(_ctx.$t("in brokering")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_input, {
                              label: _ctx.$t('Pieces'),
                              "label-placement": "floating",
                              type: "number",
                              min: "1",
                              "clear-input": "true",
                              modelValue: _ctx.selectedVariants[item.productId],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.selectedVariants[item.productId]) = $event)
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    disabled: !_ctx.isAnyVariantSelected(),
                    onClick: _ctx.releaseAlert,
                    fill: "outline",
                    color: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.send
                      }, null, 8, ["icon"]),
                      _createTextVNode(_toDisplayString(_ctx.$t("Release")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_ion_button, {
                    disabled: !_ctx.isAnyVariantSelected(),
                    onClick: _ctx.openWarehouseList,
                    fill: "outline",
                    color: "dark",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.business
                      }, null, 8, ["icon"]),
                      _createTextVNode(_toDisplayString(_ctx.$t("Release to a warehouse")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_ion_button, {
                    disabled: !_ctx.isAnyVariantSelected(),
                    onClick: _ctx.cancelAlert,
                    fill: "outline",
                    color: "danger",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.closeCircle
                      }, null, 8, ["icon"]),
                      _createTextVNode(_toDisplayString(_ctx.$t("Cancel")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}